import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from 'signup-constants/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TITLE_CENTERED_STEPS = [Step.ExistingUser, Step.Verification, Step.CodeVerification];
const StyledStepTitleText = styled.span.withConfig({
  displayName: "StepTitle__StyledStepTitleText"
})(["display:block;font-size:2rem;font-weight:700;", " ", " @media ", "{", " ", " ", " ", "}"], props => TITLE_CENTERED_STEPS.includes(props.$stepKey) && `text-align: center;`, props => props.theme.embedded && `margin-top: 20px;
  text-align: center;
  font-size: 1.75rem;`, devices.desktop, props => props.$updateStyling && 'line-height: 45px;', props => props.$updateStyling && props.$stepKey !== Step.Password && `padding-left: 50px;
    padding-right: 50px;`, props => props.$stepKey === Step.JobRole && `padding-left: 75px;
      padding-right: 75px;`, props => (props.$stepKey === Step.OptionalPhoneNumber || props.$stepKey === Step.PhoneNumber) && `padding-left: 35px;
        padding-right: 35px;`);
export const StepTitle = ({
  stepKey,
  message = null,
  className = '',
  children,
  shouldShowDefault = true,
  updateStyling = false,
  messageOptions
}) => {
  const title = useSelector(getStepTitle);
  const classNames = `${stepKey} ${className}`;
  const {
    layoutType
  } = useLayoutTemplate();
  const theme = useTheme();
  const shouldSetH2MarginBlockEndTo200 = isTrellisTheme(theme) && stepKey === Step.ExistingUser;
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const isExistingUser = stepKey === Step.ExistingUser;
  if (isSidePanel && !isExistingUser) {
    if (messageOptions && message && isValidI18nKey(message)) {
      return /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "400",
        typography: "heading-600",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message,
          options: messageOptions
        })
      });
    }
    return /*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "400",
      typography: "heading-600",
      children: shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: message || title
      })
    });
  }
  return /*#__PURE__*/_jsx(H2, {
    "aria-level": 2,
    marginBlockEnd: shouldSetH2MarginBlockEndTo200 ? '200' : undefined,
    children: /*#__PURE__*/_jsxs(StyledStepTitleText, {
      $stepKey: stepKey,
      $updateStyling: updateStyling,
      className: classNames,
      children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: message || title
      }), children]
    })
  });
};